/**
 * projectName 租户间稿库收到
 * createTime 2019-05-20
 * name zhang.yingyu
 */
angular.module("receiveTenantModule", ["receiveTenantLeftModule"]).controller("receiveTenantCtrl", ['$scope', '$q', '$modal', '$state', 'trsHttpService', 'modalDialog', 'trsspliceString', 'initSingleSelecet', 'resCtrModalService', '$stateParams', 'resourceCenterService', 'storageListenerService', 'localStorageService', '$filter',
    function($scope, $q, $modal, $state, trsHttpService, modalDialog, trsspliceString, initSingleSelecet, resCtrModalService, $stateParams, resourceCenterService, storageListenerService, localStorageService, $filter) {
        initStatus();
        initData();
        /**
         * [initStatus 初始化状态]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                "CURRPAGE": 1,
                "PAGESIZE": 20,
                "ITEMCOUNT": 0,
                "PAGECOUNT": 1,
            };
            $scope.status = {
                copyCurrPage: 1,
                id: $stateParams.id,
                isUGC: false,
                flag: true,
                isTenant: true,
            };
            $scope.iWoDocStatusName = initSingleSelecet.iWoDocType().filter((item) => {
                return item.value != 9 && item.value != 11;
            });
            $scope.iWoDocStatusSelected = angular.copy($scope.iWoDocStatusName[0]);
            $scope.data = {
                items: [],
                selectedArray: [],
                selectedPanel: [],
                operFlags: [],

            };
            $scope.params = {
                serviceid: "mlf_PluralisticShare",
                methodname: "receivedGroups",
                type: '',
                tenantId: '',
                CURRPAGE: $scope.page.CURRPAGE,
                PAGESIZE: $scope.page.PAGESIZE,
            };
        }

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                $scope.status.flag = false;
                requestData().then(function() {
                    getLocalStorageForData($scope.data.items);
                });
                storageListenerService.removeListener("resource");
            }, $scope);
        }
        /**
         * [initData 初始化数据]
         * @return {[type]} [description]
         */
        function initData() {
            listenStorage();
            if (!$scope.status.id) return;
            $scope.params.tenantId = $scope.status.id;
            requestData().then(function() {
                getLocalStorageForData($scope.data.items);
            });
        }
        /**
         * [requestData description]请求面板数据
         * @return {[type]} [description]
         */
        function requestData() {
            var defer = $q.defer();
            if ($scope.data.fromdate && $scope.data.untildate) {
                $scope.params.startTime = $scope.data.fromdate;
                $scope.params.endTime = $scope.data.untildate;
            } else {
                delete $scope.params.startTime && delete $scope.params.endTime;
            }
            $scope.keywords === '' ? delete $scope.params.searchword : $scope.params.searchword = $scope.keywords;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.data.items = data.data;
                // $scope.page.ITEMCOUNT = data.PAGER.ITEMCOUNT;
                // $scope.page.PAGESIZE = data.PAGER.PAGESIZE;
                $scope.data.selectedArray = [];
                defer.resolve(data.data);
            });
            return defer.promise;
        }

        /**
         * [getLocalStorageForData 根据缓存的记录展开面板]
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function getLocalStorageForData(data) {
            var localStorage = JSON.parse(localStorageService.get('tenantManuscriptPanel'));
            if ($scope.data.items.length > 0) {
                var selectedPanel = localStorage[$stateParams.id];
                if (angular.isUndefined(selectedPanel)) return;
                for (var i = 0; i < selectedPanel.length; i++) {
                    for (var k = 0; k < $scope.data.items.length; k++) {
                        if (selectedPanel[i] == $scope.data.items[k].groupDate) {
                            $scope.selectPanel($scope.data.items[k]);
                            break;
                        }
                    }
                }
            }
        }

        /**
         * [queryByDropdown 下拉框操作]
         * @param  {[type]} params [description]
         * @param  {[type]} value  [description]
         * @return {[type]}        [description]
         */
        $scope.queryByDropdown = function(params, key) {
            $scope.params[params] = key.value;
            $scope.data.selectedPanel = [];
            requestData().then(function() {
                if ($scope.data.items.length > 0) $scope.selectPanel($scope.data.items[0]);
            });
        };

        /**
         * [queryByTime 根据时间查询]
         * @return {[type]} [description]
         */
        $scope.queryByTime = function() {
            $scope.data.selectedPanel = [];
            requestData().then(function() {
                if ($scope.data.items.length > 0) $scope.selectPanel($scope.data.items[0]);
            });
        };

        /**
         * [querySearch 快速检索]
         * @return {[type]} [description]
         */
        $scope.querySearch = function(event) {
            if (!!event && event.keyCode == 13) {
                requestData().then(function(data) {
                    $scope.status.flag = false;
                    if (data.length > 0) $scope.selectPanel($scope.data.items[0]);
                });
            } else if (!event) {
                requestData().then(function(data) {
                    $scope.status.flag = false;
                    if (data.length > 0) $scope.selectPanel($scope.data.items[0]);
                });
            }
        };

        /**
         * [getListData 获取稿件数据]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        function getListData(item) {
            var params = angular.copy($scope.params);
            params.serviceid = 'mlf_PluralisticShare';
            params.methodname = 'receivedList';
            params.startTime = item ? item.groupDate : $scope.data.fromdate;
            params.endTime = item ? item.groupDate : $scope.data.untildate;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                if (data.success == true) {
                    item.DOCS = angular.forEach(data.data, function(item, index) {
                        item.METADATAID = item.srcId;
                        item.imgurl = thumbnail(item.picList);
                        item.DOCTYPEID = item.type;
                    });
                    if (item.DOCS.length > 0) {
                        initFlag(item.DOCS);
                        getDraftRecord(item.DOCS);
                    }
                    $scope.status.flag = true;
                }
            });
        }

        /**
         * [panelIsSelected description] 当前面板稿件是否全部选中
         * @param  {[type]} items [description] 当前面板
         * @return {[type]}       [description]
         */
        $scope.panelIsSelected = function(items) {
            if (!items) return false;
            if (items.length === 0) return false;
            for (var i = 0; i < items.length; i++) {
                if ($scope.data.selectedArray.indexOf(items[i]) < 0)
                    return false;
            }
            return true;
        };

        /**
         * [thumbnail 格式化缩略图]
         * @param  {[type]} imgList [description]
         * @return {[type]}         [description]
         */
        function thumbnail(imgList) {
            var list = JSON.parse(imgList);
            if (list.length > 0) {
                for (var i = 0; i < list.length; i++) {
                    list[i].PICSLOGO = list[i].appfile;
                }
            }
            return list;
        }

        /**
         * [selectPanel 选择面板]
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectPanel = function(item) {
            var n = $scope.data.selectedPanel.indexOf(item.groupDate);
            if (n > -1) {
                if ($scope.status.flag)
                    $scope.data.selectedPanel.splice(n, 1);
                else
                    getListData(item);
            } else {
                $scope.data.selectedPanel.push(item.groupDate);
                getListData(item);
            }
            var obj = {};
            obj[$stateParams.id] = $scope.data.selectedPanel;
            localStorageService.set('tenantManuscriptPanel', JSON.stringify(obj));
        };

        /**
         * [selectedAllDoc description] 全选当前面板的稿件
         * @param  {[type]} items [description] 当前面板
         * @return {[type]}       [description]
         */
        $scope.selectedAllDoc = function(items) {
            if (!!items) {
                var panelAllSelected = true;
                for (var i = 0; i < items.length; i++) {
                    if ($scope.data.selectedArray.indexOf(items[i]) < 0) {
                        $scope.data.selectedArray.push(items[i]);
                        panelAllSelected = false;
                    }
                }
                if (panelAllSelected === true) {
                    for (var j = 0; j < items.length; j++) {
                        if ($scope.data.selectedArray.indexOf(items[j]) > -1)
                            $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(items[j]), 1);
                    }
                }
            }
        };

        /**
         * [singleSelectedDoc description] 单选
         * @param  {[type]} item [description] 当前数据
         * @return {[type]}      [description]
         */
        $scope.singleSelectedDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            index > -1 ? $scope.data.selectedArray.splice(index, 1) : $scope.data.selectedArray.push(item);
        };

        /**
         * [getType 获取稿件类型名字]
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        $scope.getType = function(type) {
            var typeName = $scope.iWoDocStatusName.filter(function(item) {
                return item.value == type;
            })[0];
            return typeName.name;
        };

        /**
         * [getRelatedMediaIcon description] 获取相关媒体的icon字
         * @param  {[type]} relatedMedia [description]
         * @return {[type]}              [description]
         */
        $scope.getRelatedMediaIcon = function(relatedMedia) {
            relatedMedia.icon = relatedMedia.media == '1' ? "#icon-duan-xuanzhong" : relatedMedia.media == '2' ? "#icon-wang-xuanzhong1" : relatedMedia.media == '3' ? "#icon-bao-xuanzhong" : relatedMedia.media == '4' ? "#icon-xin_s" : relatedMedia.media == '5' ? "#icon-bo_s" : "";
        };

        /**
         * [fetchManuscript 取稿]
         * @return {[type]} [description]
         */
        $scope.fetchManuscript = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType("请先选择稿件！", "", "warning", false, "");
                return;
            }
            for(let i=0;i<$scope.data.selectedArray.length;i++){
                if($scope.data.selectedArray[i].status === 1){
                    modalDialog.alertType('', '选择列表中包含已经撤稿的稿件，请重新选择', 'warning', 'confirm');
                    return;
                }
            }
            if (!selectedSingleDoctype()) {
                modalDialog.alertType("批量取稿只允许选择一种稿件类型", "", "error", "confirm", function() {});
                return;
            }
            var ids = trsspliceString.spliceString($scope.data.selectedArray, "id", ",");
            var params = {
                serviceid: "mlf_PluralisticShare",
                methodname: "takeArticle",
                dataIds: ids,
                SourceName: '资源中心-租户间稿库-收到'
            };
            var isOnlyOne = ids.split(",").length > 1 ? false : true;
            var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray, $scope.status.isUGC, false);
            modalInstance.result.then(function() {
                initFlag($scope.data.selectedArray);
                getDraftRecord($scope.data.selectedArray);
                // initOperFlag($scope.data.selectedArray);
                // getDraftRecord($scope.data.selectedArray);
                $scope.data.selectedArray = [];
            }, function() {
                // initOperFlag($scope.data.selectedArray);
                // getDraftRecord($scope.data.selectedArray);
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [selectedDoctype description] 判断选中稿件是否属于同一类型openTakeDraftModal
         * @return {[type]} [description]
         */
        function selectedSingleDoctype() {
            var doctype = $scope.data.selectedArray[0].type;
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if (doctype != $scope.data.selectedArray[i].type) {
                    return false;
                }
            }
            return true;
        }

        /**
         * [collect 收藏]
         * @return {[type]} [description]
         */
        $scope.collect = function() {
            var ids = trsspliceString.spliceString($scope.data.selectedArray, "id", ",");
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'collectShareDoc',
                dataIds: ids,
            };
            resourceCenterService.collectDocs(params).then(function(data) {
                modalDialog.alertType("收藏成功!", "", "success", false, "");
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [CreationAxis 个人素材]
         */
        $scope.CreationAxis = function() {
            if (!$scope.data.selectedArray.length) {
                modalDialog.alertType("请先选择稿件！", "", "warning", false, "");
                return;
            }
            for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                if ($scope.data.selectedArray[i].type > 2) {
                    modalDialog.alertType("只能添加新闻和图集!", "", "error", false, "");
                    return;
                }
            }
            var ids = trsspliceString.spliceString($scope.data.selectedArray, "id", ",");
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'addPersonalMaterialFromShare',
                dataIds: ids,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                if (data.message) {
                    modalDialog.alertType("", data.message, "error", false, function() {
                        $scope.data.selectedArray = [];
                    });
                } else {
                    modalDialog.alertType("添加成功!", "", "success", false, function() {
                        $scope.data.selectedArray = [];
                    });
                }
            });
        };

        /**
         * [initFlag description]
         * @return {[type]} [description]
         */
        function initFlag(items) {
            var ids = trsspliceString.spliceString(items, "id", ",");
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'queryFlag',
                dataIds: ids
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var temp = data;
                for (var i in temp) {
                    if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf("1") > -1) {
                        $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                    }
                }
            });
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description] 稿件id
         * @param  {[type]} flagIndex [description] 取签见撤重序号
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) { //share
            var temp = queryItemBYID(guid);
            if (!!temp) {
                return queryItemBYID(guid).OPERFLAG.substr(flagIndex, 1) == "1" ? true : false;
            } else {
                return false;
            }
        };
        /**
         * [queryItemBYID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description] 稿件id
         * @return {[type]}      [description]
         */
        function queryItemBYID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].SHAREID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        $scope.tenantManuscriptPreview = function(item) {
            storageListenerService.previewPageTurningStorage(item, "id,srcId", 'tenantManuscriptPreview');
        };

        /**
         * [getDraftRecord 取稿记录]
         * @param  {[type]} items [description]
         * @return {[type]}       [description]
         */
        function getDraftRecord(items) {
            var ids = trsspliceString.spliceString(items, 'id', ',');
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'queryQuOpersList',
                dataIds: ids,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                // for (var i = 0; i < items.length; i ++) {
                //     items[i].OPERUSER = data[items[i].id][0].OPERUSER;
                // }
                for (var i = 0; i < items.length; i++) {
                    var operUsers = data[items[i].id];
                    operUsers = $filter('unique')(operUsers, 'OPERUSER');
                    items[i].OPERUSER = trsspliceString.spliceString(operUsers, "OPERUSER", " ").split(" ");
                }
            });
        }

        /**
         * [viewBigDataInfo description] 取签见撤重 点击弹出
         * @param  {[type]} ChnlDocId  [description] 稿件id
         * @param  {[type]} showRepeat [description] 类型
         * @return {[type]}            [description]
         */
        $scope.viewInfo = function(ChnlDocId, showRepeat, showClick, isUGC, isTenant) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var params = {
                serviceid: 'mlf_PluralisticShare',
                methodname: 'queryFlagList',
                dataId: ChnlDocId,
            };
            var infoModal = resCtrModalService.infoModal(ChnlDocId, showRepeat, showClick, operFlags, isUGC, isTenant);
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description] 稿件id
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].SHAREID) {
                    return $scope.data.operFlags[i];
                }
            }
        }
    }
]);